import { SpriteTweenSpineAdapter } from './SpriteTweenSpineAdapter.js';

/**
 * Single swap point for Spine integration: change this file to return your Spine adapter.
 *
 * @param {import('pixi.js').Container} displayObject
 * @param {object} [options] Passed through to the concrete adapter (e.g. idleMode, animationController).
 * @returns {import('./SpineAdapter.js').SpineAdapter}
 */
export function createSpineAdapter(displayObject, options) {
  return new SpriteTweenSpineAdapter(displayObject, options);
}
